export default () => {
  $(".table-link").on('click', (e) => {
    window.location.href = $(e.target).parents('tr').data('href');
  });
};
